import React from "react";

const Skill = () => {
  return (
          <div> 
          <h4 className="resume-heading">Programming Skill</h4>    
    <div id="skill" className="resume_screen_container programming-skills-container">
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>HTML5</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "95%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>CSS3</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "85%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>Tailwind CSS</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "70%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>Material UI</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "80%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>React Bootstrap</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "85%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>Bootstrap</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "95%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>SASS</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "95%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>JavaScript</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "95%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>ES6</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "95%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>TypeScript Js</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "40%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>React.js</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "90%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>React Router Dom</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "80%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>Context API</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "80%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>Redux.js</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "50%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>Node.js</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "60%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>Express.js</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "60%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>MongoDB</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "60%" }}></div>
        </div>
      </div>
      <div className="skill_parent">
        <div className="heading_bullet"></div>
        <span>Next JS</span>
        <div className="skill_percentage">
          <div className="active_percentage_bar" style={{ width: "60%" }}></div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default Skill;
